<template>
  <v-card>
    <v-card-text>
      Loading
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PaymentSuccess",
  props: {
    secret: {
      type: String,
      required: true,
    },
  },
  mounted() {
    location.href = `/event/payment/success/${this.secret}`
    // gtag('event', 'conversion', { 'send_to': 'AW-756988716/RzYOCJHI84oDEKz2-ugC', 'transaction_id': this.secret });
  }
}
</script>

<style lang="scss" scoped></style>
